import { React, Fragment, memo, useEffect, useState } from 'react'
import {
  HeadingText,
  BodyText,
  Button,
  Row,
  Col,
  Link,
  Avatar,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { fptiCustomImpression } from '../../../utils'
import { VENMOPAGE } from '../../../constants/constants'

const PasswordRecovery = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(props.fpti.PASSWORD_SENT)
    }
  }, [])

  const handleGotit = (event) => {
    event.preventDefault()
    location.href = VENMOPAGE
  }

  const handleResend = (event) => {
    event.preventDefault()
    location.reload()
  }

  return (
    <Fragment>
      <div className="flex-center">
        <Avatar
          src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-success.svg"
          className="focusedimg"
          alt="success"
        />
      </div>

      <HeadingText
        id="password-recovery-header"
        size="sm"
        className="text-center requestForm-row"
      >
        <Message id="closedAccountPages.passwordsent.title" />
      </HeadingText>

      <Row>
        <Col>
          <BodyText className="text-center requestForm-row">
            <Message
              id="closedAccountPages.passwordsent.description"
              phonenumber={props.response.masked_phone_number || ''}
            />
          </BodyText>
        </Col>
      </Row>

      <div className="text-center requestForm-row">
        <Button theme="v2" id="gotbtn" onClick={handleGotit}>
          <Message id="closedAccountPages.gotitbtn.lable" />
        </Button>
      </div>

      <div className="text-center requestForm-row">
        <Link title="Primary" onClick={handleResend}>
          <Message id="closedAccountPages.resendbtn.lable" />
        </Link>
      </div>
    </Fragment>
  )
})

PasswordRecovery.displayName = 'PasswordRecovery'
export default PasswordRecovery
